import { Component, OnInit, Input, Inject, Optional } from '@angular/core';
import { ProgressSpinnerMode } from '@angular/material/progress-spinner';
import { DATA_TOKEN } from 'src/app/services/spinner.service';

@Component({
  selector: 'app-mat-spinner-overlay',
  templateUrl: './mat-spinner-overlay.component.html',
  styleUrls: ['./mat-spinner-overlay.component.scss']
})
export class MatSpinnerOverlayComponent implements OnInit {

  constructor(@Optional() @Inject(DATA_TOKEN) private data: string) {

    if (data !== null && data !== ''){
      this.text = data;
    }
  }

  @Input() diameter: number = 30;
  @Input() mode: ProgressSpinnerMode = "indeterminate";
  @Input() strokeWidth: number = 2;
  @Input() color: string = "primary";
  @Input() text: string = "Vent litt...";

  ngOnInit() {

  }

}